<template>
  <div>
    <b-modal
      size="lg"
      ref="redeem-store-credit"
      title="Store Credit"
      hide-footer
      centered
      @hidden="closeRedeemStoreModal"
      scrollable
    >
      <b-row v-if="isError != 'success'">
        <b-col lg="6">
          <label class="mr-sm-2">Redeem with</label>
          <b-form-select
            v-model="redeemTypes"
            :options="options"
            class="mb-2 mr-sm-2 mb-sm-0"
            id="redeem-types"
          ></b-form-select>
        </b-col>

        <b-col lg="6">
          <div v-if="redeemTypes == 'number'">
            <label class="mr-sm-2" id="label-cust-number-storecredit"
              >Customer phone number</label
            >
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              id="cust-number-storecredit"
              placeholder="Enter customer’s phone number"
              maxlength="10"
              v-model="phoneValue"
              type="number"
              @keydown="checkLength"
              v-on:keyup.enter="applyOTP"
              :disabled="$loading"
              @click="clearField"
            ></b-form-input>
          </div>

          <div v-if="redeemTypes == 'voucher'">
            <label class="mr-sm-2" id="label-voucher-input-storecredit"
              >Voucher Code</label
            >
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              v-model="inputValue"
              id="voucher-input"
              placeholder="Enter your 6 digits code here…"
              v-on:keyup.enter="applyVoucher"
              :disabled="$loading"
              min="0"
              maxlength="6"
              @click="clearField"
            ></b-form-input>
          </div>
          <div v-show="redeemTypes == 'number'">
            <label class="mt-1 mb-0"
              >Note: Number should be same as tagged customer’s number.</label
            >
          </div>
        </b-col>

        <b-col lg="6" v-if="otp && couponList == '' && redeemTypes == 'number'">
          <div id="otp-section">
            <label class="mr-sm-2 w-100 mt-3" id="label-enter-otp"
              >Enter OTP sent to the customer’s number</label
            >
            <!-- <b-row class="mt-2 no-gutters">
              <b-col md="1" class="input mr-2">
                <b-form-input
                  type="password"
                  class="active text-center"
                  maxlength="1"
                  required
                  v-model="otpInput"
                ></b-form-input>
              </b-col>
              <b-col md="1" class="input mr-2">
                <b-form-input
                  type="password"
                  class="text-center"
                  maxlength="1"
                  required
                  v-model="otpInput"
                ></b-form-input>
              </b-col>
              <b-col md="1" class="input mr-2">
                <b-form-input
                  type="password"
                  class="text-center"
                  maxlength="1"
                  required
                  v-model="otpInput"
                ></b-form-input>
              </b-col>
              <b-col md="1" class="input mr-2">
                <b-form-input
                  type="password"
                  class="text-center"
                  maxlength="1"
                  required
                  v-model="otpInput"
                ></b-form-input>
              </b-col>
              <b-col md="1" class="input mr-2">
                <b-form-input
                  type="password"
                  class="text-center"
                  maxlength="1"
                  required
                  v-model="otpInput"
                ></b-form-input>
              </b-col>
              <b-col md="1" class="input mr-2">
                <b-form-input
                  type="password"
                  class="text-center"
                  maxlength="1"
                  required
                  v-model="otpInput"
                ></b-form-input>
              </b-col>
            </b-row>-->
            <b-input-group>
              <b-form-input
                type="number"
                class="active text-center"
                placeholder="Enter 6 digits otp number"
                required
                v-model="otpInput"
                v-on:keyup.enter="verifyOTP"
                max="6"
                :disabled="$loading"
                id="input-otp"
              ></b-form-input>

              <b-input-group-append>
                <b-button
                  variant="secondary"
                  @click="verifyOTP()"
                  :disabled="otpInput.length <= 5 || $loading"
                  id="verify-otp-btn"
                >
                  <span v-if="!$loading">Verfiy</span>
                  <b-spinner small v-if="$loading" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <div class="clearfix"></div>
      </b-row>
      <div class="clearfix"></div>
      <div class="store-credit-response">
        <table
          class="table text-center"
          v-if="voucherList.length > 0 && redeemTypes == 'voucher'"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Voucher Code</th>
              <th>Description</th>
              <th>Valid Till</th>
              <th>Amount</th>
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in voucherList" :key="list.id">
              <td v-text="index + 1" />
              <td v-text="list.voucher_no" />
              <td v-text="list.desc" />
              <td v-text="list.expired_at" />
              <td v-text="currencySymbol + formatAmount(list.amount)" />
              <!-- <td>
                <b-form-checkbox
                  id="checkbox-1"
                  name="checkbox-1"
                  value="1"
                  v-model="list.applied_status"
                  checked
                  disabled
                />
              </td>-->
            </tr>
          </tbody>
        </table>
        <table class="table text-center" v-if="couponList.length > 0">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Description</th>
              <th>Valid Till</th>
              <th>Amount</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in couponList" :key="list.id">
              <td v-text="index + 1" />
              <td v-text="list.name" />
              <td v-text="list.desc" />
              <td v-text="list.expired_at" />
              <td v-text="currencySymbol + formatAmount(list.amount)" />
              <td>
                <b-form-checkbox
                  name="checkbox-1"
                  :value="list.voucher_id"
                  v-model="list.applied_status"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="text-center"
          v-if="
            couponList.length == 0 &&
              redeemTypes == 'number' &&
              isError == 'success'
          "
        >
          No voucher found on entered mobile number.
        </div>
        <!-- <table class="table text-center" v-if="voucherList.len gth > 0">
          <thead>
            <tr>
              <th>#</th>
              <th>Credit Note</th>
              <th>Issued On</th>
              <th>Valid Till</th>
              <th>Amount</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in voucherList" :key="list.id">
              <td v-text="index+1"></td>
              <td v-text="list.credit_note"></td>
              <td v-text="list.issue_on"></td>
              <td v-text="list.expire_at"></td>
              <td>{{currencySymbol}}{{list.amount}}</td>
              <td>
                <b-form-checkbox
                  name="checkbox-1"
                  :value="list.voucher_id"
                  v-model="list.applied_status"
                  :checked="list.status == 1"
                />
              </td>
            </tr>
          </tbody>
        </table>-->
      </div>
      <b-row class="mt-4 credit-footer align-items-center">
        <b-col class="text-danger">
          <div v-if="isError != '' && isError == 'fail'">
            <img src="../assets/images/alert.svg" alt />
            {{ validated }}
          </div>
          <div
            class="text-success"
            v-if="isError == 'success' && vocherAmt != ''"
          >
            Credit applied! <span v-text="currencySymbol" />
            <span
              v-if="
                isError == 'success' &&
                  vocherAmt != '' &&
                  redeemTypes == 'voucher'
              "
              v-text="formatAmount(vocherAmt)"
            />
            <span
              v-if="
                isError == 'success' &&
                  this.couponAmt != '' &&
                  redeemTypes == 'number'
              "
              v-text="formatAmount(couponAmt)"
            />
            off
          </div>
        </b-col>
        <b-col>
          <!--  <b-button
            class="btn grey-btn float-right"
            @click="applyOTP"
            v-if="isError != 'success'|| this.redeemTypes == 'number'"
            :disabled="isBtnDisabled"
          >
            <span v-if="$loading == false">{{ btnText }}</span>
            <b-spinner small v-if="$loading == true"></b-spinner>
          </b-button>-->
          <b-button
            class="float-right"
            variant="primary"
            @click="applyVoucher"
            v-if="
              (redeemTypes == 'voucher' && isError == '') ||
                (isError == 'success' && redeemTypes == 'number')
            "
            :disabled="
              $loading ||
                isBtnDisabled ||
                (couponList.length == 0 &&
                  redeemTypes == 'number' &&
                  isError == 'success')
            "
            id="apply-voucher-storecredit"
          >
            <span v-if="!$loading">Apply Voucher</span>
            <b-spinner small v-if="$loading" />
          </b-button>
          <b-button
            class="float-right ml-1"
            @click="applyOTP"
            v-if="this.redeemTypes == 'number' && couponList.length == 0"
            :disabled="
              $loading ||
                isBtnDisabled ||
                (couponList.length == 0 &&
                  redeemTypes == 'number' &&
                  isError == 'success')
            "
            :id="'store-credit-' + btnText"
          >
            <span v-if="!$loading" v-text="btnText" />
            <b-spinner small v-if="$loading" />
          </b-button>

          <!-- <b-button
            class="btn grey-btn float-right"
            type="button"
            @click="applyVoucher"
            v-if="redeemTypes == 'voucher' && voucherList.length > 0"
          >
            <span v-if="$loading == false">Apply Voucher</span>
            <b-spinner small v-if="$loading == true"></b-spinner>
          </b-button>-->

          <b-button
            class="float-right"
            variant="primary"
            @click="closeRedeemStoreModal"
            :disabled="$loading"
            v-if="isError == 'success' && redeemTypes == 'voucher'"
            id="continue-btn-storecredit"
            >Continue</b-button
          >
          <!-- <b-button
            class="btn btn-danger float-right mr-2"
            v-if="voucherList.length > 0 || couponList.length > 0"
            :disabled="vocherAmt == '' || couponAmt == ''"
            @click="removeVoucher"
          >
            <span v-if="$loading == false">Remove</span>
            <b-spinner small v-if="$loading == true"></b-spinner>
          </b-button>-->

          <b-button
            variant="danger"
            class="float-right mr-2"
            v-if="couponList.length > 0 && redeemTypes == 'number'"
            :disabled="couponAmt == '' || $loading"
            @click="removeVoucher"
            id="remove-btn-number-storecredit"
          >
            <span v-if="$loading == false">Remove</span>
            <b-spinner small v-if="$loading == true"></b-spinner>
          </b-button>

          <b-button
            variant="danger"
            class="float-right mr-2"
            v-if="voucherList.length > 0 && redeemTypes == 'voucher'"
            :disabled="this.vocherAmt == '' || $loading"
            @click="removeVoucher"
            id="remove-btn-voucher-storecredit"
          >
            <span v-if="!$loading">Remove</span>
            <b-spinner small v-if="$loading" />
          </b-button>
        </b-col>
      </b-row>

      <!--<b-row>
        <b-col md="6">
    
        </b-col>
      </b-row>-->
      <!--<b-col class="mt-3">
        <b-row class="head sticky-top">
          <b-col md="1" class="text-left p-0">#</b-col>
          <b-col md="4" class="text-left px-0">Credit Note</b-col>
          <b-col md="2" class="text-left">Issued on</b-col>
          <b-col md="2" class="text-left pr-4">Valid till</b-col>
          <b-col md="2" class="text-left pr-4">Amount</b-col>
          <b-col md="1" class="text-left pr-4"></b-col>
          <div class="clearfix"></div>
        </b-row>
        <b-row class="my-3" style="padding: 0.4rem;">
          <b-col md="1" class="pl-0 pr-0">
            <span>1</span>
          </b-col>
          <b-col md="4 px-0">
            <span>SCN#00203400050</span>
          </b-col>
          
          <b-col md="2" class="text-left">20 Jan 2020</b-col>
          <b-col md="2" class="text-left pr-4">31 Mar 2020</b-col>
          <b-col md="2" class="text-left pr-4">₹600.00</b-col>
          <b-col md="1" class="text-left pr-4">
            <img src="../assets/images/remove.svg" alt />
          </b-col>
          <div class="clearfix"></div>
        </b-row>
      </b-col>-->
      <!-- <b-row class="mt-4">
        <b-col class="text-danger">
          <div>
            <img src="../assets/images/alert.svg" alt />
            Invalid Code
          </div>
          <div class="text-success">Credit applied! ₹600.00 off</div>
        </b-col>

        <b-col>
          <b-button class="btn grey-btn float-right" v-b-modal.success-popup>Resend OTP</b-button>
          <b-modal id="success-popup" size="sm" hide-footer hide-header centered>
            <header class="modal-header p-0">
              <h5 class="modal-title mb-2 d-flex">
                <img src="../assets/images/success.svg" alt />&nbsp; Redemption success!
              </h5>
              <button type="button" @click="$bvModal.hide('success-popup')" class="times">
                <font-awesome-icon :icon="['fas', 'times']" />
              </button>
            </header>
            <p class="mb-4" style="color: #808080;">
              An amount of ₹30.00 has been redeemed
              against the current bill.
            </p>
            <button
              class="btn grey-btn float-right px-4"
              @click="$bvModal.hide('success-popup')"
            >Dismiss</button>
          </b-modal>
        </b-col>
      </b-row>-->
    </b-modal>
    <b-modal
      ref="pay-process"
      size="sm"
      centered
      id="pay"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header
    >
      <div v-if="$loading == true" class="m-1">
        <h6 style="font-weight: normal;">Processing Payment</h6>
        <b-progress
          :value="100"
          variant="primary"
          striped
          animated
          class="mt-3"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";
import moment from "moment";

export default {
  name: "redeem-store-credit",
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vouchAmt: "",
      type: "",
      qty: 0,
      validated: "",
      inputValue: "",
      phoneValue: "",
      redeemTypes: "voucher",
      options: [
        { text: "Credit Voucher", value: "voucher" },
        { text: "Phone Number", value: "number" },
      ],
      otp: false,
      isError: "",
      voucherList: [],
      couponList: [],
      btnText: "Continue",
      otpInput: "",
      // disableRedeemType: false
    };
  },
  watch: {
    open() {
      let self = this;
      if (this.open) {
        this.$refs["redeem-store-credit"].show();
        if (this.state.billing.billing.vocher_list.length > 0) {
          this.voucherList = this.state.billing.billing.vocher_list;
          this.isError = "success";
        }
      } else {
        this.$refs["redeem-store-credit"].hide();
      }
    },
  },
  mounted() {
    // this.getCarryBags();
    // this.phoneValue = this.state.billing.customer.data.mobile;
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    isBtnDisabled() {
      let check = true;
      let count = 0;
      let otpcount = 6;
      if (this.redeemTypes == "number") {
        count = this.state.system.country_details.phone_digit;
        if (
          this.phoneValue.length >= count && this.phoneValue.length <= count
            ? (check = false)
            : (check = true)
        );
      } else {
        count = 6;
        if (
          this.inputValue.length >= count && this.inputValue.length <= count
            ? (check = false)
            : (check = true)
        );
      }

      if (!check) {
        this.isError = "";
      }
      return check;
    },
    vocherAmt() {
      let amt = 0;
      this.voucherList.map((item) => {
        if (item.status != 0) {
          amt += parseInt(item.amount);
        }
      });
      return amt;
    },
    couponAmt() {
      let amt = 0;
      this.couponList.map((item) => {
        if (item.applied_status != false) {
          amt += parseInt(item.amount);
        }
      });
      return amt;
    },
    checkLayByAmt() {
      let layByAmt = this.state.billing.billing.layBy_Amt;
      if (this.state.billing.billing.layBy_Amt > 0) {
        if (this.state.billing.billing.order.data != "") {
          if (
            this.state.billing.billing.order.summary.amount_due != "0" &&
            this.state.billing.billing.order.data.transaction_sub_type ==
              "sales"
          ) {
            layByAmt = "";
            // console.log("cool");
          } else if (
            this.state.billing.billing.total_payable !=
              this.state.billing.billing.layBy_Amt &&
            this.state.billing.billing.order.data.transaction_sub_type ==
              "lay_by"
          ) {
            layByAmt = "";
          }
        }
      }
      return layByAmt;
    },
    getOrderIdLength() {
      let length = this.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;
      return length;
    },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1 &&
        this.state.system.isOffline == false
      ) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    checkLength(e) {
      if (
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        (e.keyCode >= 96 && e.keyCode <= 105)
      ) {
        if (this.phoneValue.length == 10) {
          return e.preventDefault();
        }
      }
    },
    closeRedeemStoreModal() {
      this.$emit("close-store", false);
    },
    verifyOTP() {
      this.$loading = true;
      let postData = {
        // c_id: this.state.c_id,
        v_id: this.state.sessions.user.vendor_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        user_type: "CUSTOMER",
        for: "GET_OFFERS",
        otp: this.otpInput,
        mobile: this.phoneValue,
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        url: "verify-otp",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios.post(data.url, data).then((res) => {
        this.$loading = false;
        if (res.data.status == "fail") {
          this.isError = res.data.status;
          this.validated = res.data.message;
        } else {
          this.$loading = false;
          let postData = {
            // c_id: this.state.c_id,
            v_id: this.state.sessions.user.vendor_id,
            store_id: this.state.sessions.user.store_id,
            vu_id: this.state.sessions.user.vu_id,
            user_type: "CUSTOMER",
            for: "GET_OFFERS",
            get_by: "phone_number",
            mobile: this.phoneValue,
            trans_from: this.state.system.trans_from,
            order_id: this.state.billing.billing.order.data.order_id,
            api_token: this.state.sessions.user.api_token,
            url: "get-offers",
          };
          let data = Object.assign(
            postData,
            this.essentialsData,
            this.customerData
          );
          axios
            .post(postData.url, data)
            .then((res) => {
              this.$loading = false;
              this.isError = "success";
              // this.btnText = "Apply";
              this.couponList = res.data.data.coupon_voucher;
              // alert("got offers");
            })
            .catch((err) => {
              this.$loading = false;
              console.log(err.response);
              // this.$bvModal.msgBoxOk(err.response.data.message);
            });
        }
      });
    },
    applyOTP() {
      this.$loading = true;
      let postData = {
        // c_id: this.state.c_id,
        v_id: this.state.sessions.user.vendor_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        user_type: "CUSTOMER",
        for: "GET_OFFERS",
        mobile: this.phoneValue,
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        url: "send-otp",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios.post(postData.url, data).then((res) => {
        this.$loading = false;
        if (res.data.status == "fail") {
          this.isError = res.data.status;
          this.validated = res.data.message;
        } else {
          this.otp = true;
          this.$loading = false;
          this.btnText = "Resend OTP";
        }
      });
    },
    applyVoucher() {
      let order_id = "";
      if (this.isOfflineEnabled) {
        order_id = this.state.billing.billing.invoice_no;
        console.log(order_id);
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }
      // this.disableRedeemType = true;
      this.$loading = true;
      let all = 0;
      let voucherList = [];
      let voucherCode = this.inputValue;
      if (this.redeemTypes == "number") {
        all = 1;
        this.couponList.map((item) => {
          if (item.applied_status != false) {
            voucherList.push({ voucher_id: item.voucher_id });
          }
        });
        voucherCode = "";
      }
      // console.log(voucherList);
      let postData = {
        responseFormat: "ARRAY",
        order_id: this.state.billing.billing.order.data.order_id,
        type: "voucher",
        all: all,
        total_payable: this.state.billing.billing.total_payable,
        voucher_id: JSON.stringify(voucherList),
        voucher_code: voucherCode,
        get_by: "",
        url: "apply-voucher",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios.post(data.url, data).then((res) => {
        // console.log(res.data.data.amount);

        // console.log(this.vouchAmt);
        if (res.data.status == "fail") {
          this.isError = res.data.status;
          this.validated = res.data.message;
          this.$loading = false;
          this.voucherList = [];
          this.couponList = [];
          this.phoneValue = "";
          this.otpInput = "";
          this.otp = false;
        } else {
          this.vouchAmt = res.data.data.amount;
          if (
            parseFloat(this.vouchAmt) <
            parseFloat(this.state.billing.billing.total_payable)
          ) {
            this.getVoucherList();
          } else {
            this.$refs["pay-process"].show();
            this.$refs["redeem-store-credit"].hide();
          }
          let insertData = {
            order_id: "",
            invoice_id: this.state.billing.billing.invoice_no,
            type: "online",
            v_id: parseInt(this.state.sessions.user.v_id),
            store_id: parseInt(this.state.sessions.user.store_id),
            vu_id: parseInt(this.state.sessions.user.vu_id),
            date: moment(new Date()).format("YYYY-MM-DD"),
            time: moment(new Date()).format("HH:mm:ss"),
          };

          let postData = {
            amount: parseFloat(this.vouchAmt),
            t_order_id: "",
            order_id: this.state.billing.billing.order.data.order_id,
            pay_id: "",
            method: "credit_note_received",
            invoice_id: "",
            bank: "",
            wallet: "",
            vpa: "",
            error_description: "",
            status: "success",
            address_id: "",
            payment_gateway_type: "VOUCHER",
            cash_collected: "",
            cash_return: "",
            lay_by_total: this.checkLayByAmt,
            lay_by_remark: "",
            transaction_sub_type:
              this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
            url: "save-payment",
            gateway_response: "",
            payment_gateway_device_type: "",
            remark: this.state.billing.billing.remark,
            invoice_seq: order_id,
          };
          let data = Object.assign(
            postData,
            this.essentialsData,
            this.customerData
          );

          this.$store
            .dispatch("billing/savePayment", data)
            .then((response) => {
              if (
                this.state.billing.total_payable == 0 ||
                this.state.billing.total_payable == "0.00"
              ) {
                if (this.isOfflineEnabled) {
                  this.$store.dispatch("billing/saveInvoiceId");
                }
              }
              let alertData = {
                message: msg.VOUCHER_SUCCESS,
                type: "success",
              };
              this.$store.commit("notifications/showAlert", alertData);
              this.$showAlert = true;
              this.$loading = false;
              this.isError = "success";
              this.btnText = "Submit";
              res.data.data.status = 1;

              // this.voucherList.push(res.data.data);
              // this.$store.commit("saveVoucherList", this.voucherList);
            })
            .catch((err) => {
              this.$loading = false;
              if (err.response.status == "fail") {
                let alertData = {
                  message: err.response.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$loading = false;
              }
              // this.$bvModal.msgBoxOk(err.response.data.message);
            });
        }
      });
    },
    getVoucherList() {
      let vouchlist = [];
      // this.$loading = false;
      let postData = {
        // c_id: this.state.c_id,
        v_id: this.state.sessions.user.vendor_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        user_type: "CUSTOMER",
        for: "GET_OFFERS",
        get_by: "VOUCHER_NO",
        mobile: this.phoneValue,
        trans_from: this.state.system.trans_from,
        order_id: this.state.billing.billing.order.data.order_id,
        api_token: this.state.sessions.user.api_token,
        url: "get-offers",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          // this.$loading = false;
          this.isError = "success";
          // console.log(res.data.data.coupon_voucher);
          vouchlist = res.data.data.coupon_voucher;
          for (var i = 0; i < vouchlist.length; i++) {
            // console.log(vouchlist[i]);
            if (vouchlist[i].applied_status == true) {
              this.voucherList.push(vouchlist[i]);
            }
          }
          this.$store.commit("billing/saveVoucherList", this.voucherList);
        })
        .catch((err) => {
          // this.$loading = false;
          console.log(err.response);
        });
    },
    removeVoucher() {
      this.$loading = true;
      let voucherId = [];
      let couponId = [];
      this.voucherList.map((item) => {
        if (item.status == 1) {
          voucherId.push({ voucher_id: item.id });
        }
      });
      this.couponList.map((item) => {
        if (item.applied_status) {
          couponId.push({ voucher_id: item.voucher_id });
        }
      });
      let postData = {
        responseFormat: "ARRAY",
        order_id: this.state.billing.billing.order.data.order_id,
        type: "voucher",
        all: this.redeemTypes == "voucher" ? 1 : 0,
        total_payable: this.state.billing.billing.total_payable,
        voucher_id:
          this.redeemTypes == "voucher"
            ? JSON.stringify(voucherId)
            : JSON.stringify(couponId),
        voucher_code: this.inputValue,
        url: "remove-voucher",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "fail") {
            this.isError = res.data.status;
            this.validated = res.data.message;
            this.$loading = false;
          } else {
            this.isError = "";
            this.phoneValue = "";
            this.inputValue = "";
            this.otpInput = "";
            this.otp = false;
            this.$store.commit("billing/saveOrderSummay", res.data);
            this.$store.commit("billing/clearVoucherList");
            // this.btnText = "Apply";
            this.voucherList = [];
            this.couponList = [];
            this.$emit("close-store", false);
            this.$store.commit(
              "billing/getTotalPayable",
              res.data.order_summary.total_payable
            );
            this.$loading = false;
          }
        })
        .catch((err) => {
          this.$loading = false;
          console.log(err);
        });
    },
    // checkBoxValue(data) {
    //   // console.log(data);
    //   let value = 0;
    //   if (data.applied_status == false) {
    //     value += parseInt(data.amount);
    //   }
    //   console.log(value);
    // }
    clearField() {
      if (this.redeemTypes == "number") {
        this.isError = "";
        // this.phoneValue = "";
      }
      if (this.redeemTypes == "voucher") {
        this.isError = "";
        // this.inputValue = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#redeem-types {
  font-size: 12px;
}
.modal-body .custom-select {
  appearance: inherit !important;
  -webkit-appearance: inherit !important;
  -moz-appearance: inherit !important;
}
.store-credit-response {
  margin: 15px 0;
  border: 0px solid red;
  .table tr th {
    background-color: #c0c0c0;
    font-weight: normal;
    padding: 4px 2px;
    font-size: 11.5px;
  }
}
.credit-footer {
  border-top: 1px solid #f0f0f0;
  padding-top: 15px;
}
</style>
